import type { IconVariants } from '@uikit/components/Icon/interfaces';
import type { ProductOption } from './types';

export const PRODUCT_BUTTON_ICONS: Record<ProductOption, IconVariants> = {
  power: 'user/lightning',
  gas: 'user/energy-fire',
  combined: 'user/calculator',
};

export const PRODUCT_OPTIONS_ORDER: ProductOption[] = [
  'combined',
  'power',
  'gas',
];

export const STAGE_BOX_SEGMENTED_CONTROL_CONFIG: {
  icon: IconVariants;
  label: string;
  value: ProductOption;
}[] = [
  {
    icon: 'user/lightning',
    label: 'Ökostrom',
    value: 'power',
  },
  {
    icon: 'user/energy-fire',
    label: 'Gas',
    value: 'gas',
  },
  {
    icon: 'user/power-gas',
    label: 'Kombi',
    value: 'combined',
  },
];

export const backgroundTypeToRadioGroupColor = {
  gradient: 'white',
  white: 'default',
} as const;

export const stageBoxSegmentedControlColorMap = {
  gradient: 'white',
  white: 'surrogate',
} as const;
